import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const ChevronDownIcon = createIcon(
  'ChevronDown',
  <path d="M17.5480984,7.41879195 L11.9928412,12.9740492 L6.43758389,7.41879195 C5.87919463,6.86040268 4.97718121,6.86040268 4.41879195,7.41879195 C3.86040268,7.97718121 3.86040268,8.87919463 4.41879195,9.43758389 L10.990604,16.009396 C11.5489933,16.5677852 12.4510067,16.5677852 13.009396,16.009396 L19.5812081,9.43758389 C20.1395973,8.87919463 20.1395973,7.97718121 19.5812081,7.41879195 C19.0228188,6.87472036 18.1064877,6.86040268 17.5480984,7.41879195 L17.5480984,7.41879195 Z"/>
);

export default ChevronDownIcon;
